<template>
  <AutoComplete
    v-model="value"
    multiple
    dropdown
    :suggestions="data"
    @complete="search"
    optionLabel="groupName"
  >
    <template #option="slotProps">
      <div class="p-1">
        <Tree
          v-model:selectionKeys="dataNode"
          :value="[slotProps.option]"
          selectionMode="checkbox"
          class="w-full p-0 m-0"
        ></Tree>
      </div>
    </template>
    <template #footer
      ><div class="flex gap-2 p-2 justify-content-end">
        <Button label="Chọn" icon="pi pi-check"></Button
        ><Button label="Bỏ qua" severity="secondary" icon="pi pi-times"></Button></div
    ></template>
  </AutoComplete>
</template>
<script setup>
import { ref } from "vue";

const value = ref([]);
const dataNode = ref([]);
const data = ref([]);

const search = () => {
  let _items = [
    {
      id: 8,
      groupName: "Test 9",
      groupType: "C",
      parentId: null,
      child: [
        {
          id: 9,
          groupName: "test 6",
          groupType: "C",
          parentId: 8,
          child: [],
        },
        {
          id: 10,
          groupName: "test 3",
          groupType: "C",
          parentId: 8,
          child: [],
        },
        {
          id: 11,
          groupName: "ted 3",
          groupType: "C",
          parentId: 8,
          child: [],
        },
        {
          id: 14,
          groupName: "9 con",
          groupType: "C",
          parentId: 8,
          child: [],
        },
      ],
    },
    {
      id: 12,
      groupName: "Test 10",
      groupType: "C",
      parentId: null,
      child: [
        {
          id: 13,
          groupName: "10 con",
          groupType: "C",
          parentId: 12,
          child: [],
        },
      ],
    },
  ];
  data.value = _items;
  ConvertData(data.value);
};

const ConvertData = (data, parentKey = "") => {
  for (let index = 0; index < data.length; index++) {
    const item = data[index];
    // item.key = item.parentId != null ? item.parentId + "-" + item.id : item.id;
    // item.key = parentKey != "" ? parentKey + "-" + item.id : item.key;
    item.label = item.groupName;
    if (item.child.length) {
      item.children = item.child;
      ConvertData(item.child, item.key);
    }
  }
};
</script>
